import generateDirective from 'angular/customer_application_bootstrap/angular/components/generator';
const controller = require('./controller');

generateDirective(
  'Declined',
  '/customer_application_renderer/stages/declined/form.html',
  controller
);
